module.exports = {"IMAGE_WIDTH":150,"IMAGE_HEIGHT":150,"IMAGE_QUALITY":90}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/theme/productList.json
// module id = 1366
// module chunks = 1